/**
 * @module app.prospection.store.walletCreateUpdateClientCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function WalletCreateUpdateClientCtrl(
        $scope,
        $rootScope,
        $uibModalInstance,
        clientService,
        $log,
        client,
        storeTypes,
        activities,
        store,
        Notification,
        storeTypeService
    ) {
        var self = {};
        self.client = client[0];
        self.storeType = storeTypes;
        self.activities = activities;
        self.store = store;

        if (!self.client.id && !self.client.storeId) {
            self.client = clientService.getClientObject();
        }
        else if (self.client.storeType === null) {
            self.client.storeType = {
                id: null,
                code: null,
                label: null
            };
        }

        // storeType initialisation for form

        if (self.client.storeType.id === null) {
            self.client.storeType = {
                id: self.storeType[0].id,
                code: self.storeType[0].code,
                label: self.storeType[0].label
            };
        }

        self.isCreationLoading = false;

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        /**
         * Is a client update
         * @return {Boolean}
         */
        self.isUpdate = function () {
            return self.client.id;
        };

        /**
         * update client
         */
        self.updateClient = function () {
            self.isCreationLoading = true;
            if (self.store.stat2_label === 'NAP') {
                self.client.storeType = self.storeType.find(function(storeType) {
                    return storeType.code === self.client.storeType.code;
                });
            }
            else {
                self.client.storeType = {
                    id: null,
                    code: null,
                    label: null
                };
            }

            clientService
                .createUpdate(self.client)
                .then(function(client) {
                    if (self.client.id) {
                        Notification.success('Le client a bien été mis à jour');
                    }
                    self.client = client;
                    $uibModalInstance.close(self.client);
                })
                .catch(function(err) {
                    $log.error(err);
                    Notification.error('Une erreur est survenue : ' + err.data);
                })
                .finally(function() {
                    self.isCreationLoading = false;
                });
        };

        return self;
    }

    WalletCreateUpdateClientCtrl.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'clientService',
        '$log',
        'client',
        'storeTypes',
        'activities',
        'store',
        'Notification',
        'storeTypeService'
    ];

    angular
        .module('app.prospection.store.walletCreateUpdateClientCtrl', ['ui.bootstrap.modal', 'ui-notification'])
        .controller('WalletCreateUpdateClientCtrl', WalletCreateUpdateClientCtrl);
});
